import React, { useEffect, useState } from "react";
import {
  availableModules,
  subscribedModules,
} from "../../Admin/dummydata/modules";
import { Input, InputNumber, Select } from "antd";
import {
  updateCompanyDetails,
  initializeEditCompanyForm,
  makeAddModeTrue,
  makeEditModeFalse,
  makeAddModeFalse,
} from "../../../redux/Admin/adminActions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useGetActiveModules } from "../../../hooks/useGetActiveModules";
import LoadingSpinner from "./loaders/LoadingSpinner";
import SuccessPopup from "./modals/SuccessModal";
import ErrorPopup from "./modals/ErrorModal";
import SkeletonUI from "./loaders/SkeletonUI";

const { Search } = Input;

export default function ClientDetails({
  companyDetail,
  isEdit = false,
  addNewDetails = false,
}) {
  const dispatch = useDispatch();

  const location = useLocation();
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.includes("add-client")) {
      dispatch(makeAddModeTrue());
      dispatch(makeEditModeFalse());
    }

    return () => {
      dispatch(makeAddModeFalse());
      dispatch(makeEditModeFalse());
    };
  }, [dispatch, location.pathname]);

  const editCompany = useSelector((state) => state.admin.editCompany);
  const sitePrefix = companyDetail?.site && companyDetail?.site.split(".")[0];

  const moduleNamesString = subscribedModules
    .map((module) => module.name)
    .join(", ");
  // Initialize form data when component mounts or companyDetail changes
  useEffect(() => {
    console.log(companyDetail, "at form");

    if (isEdit && companyDetail && !addNewDetails) {
      dispatch(
        initializeEditCompanyForm({
          name: companyDetail?.name || "",
          email: companyDetail?.email || "",
          contact: companyDetail?.phone || "",
          site: sitePrefix || "",
          users: companyDetail?.users || "",
          subscribedModules:
            moduleNamesString && moduleNamesString.length > 0
              ? moduleNamesString.split(", ")
              : [],
        })
      );
    }

    return () => {
      dispatch(
        initializeEditCompanyForm({
          name: "",
          email: "",
          contact: "",
          site: "",
          users: "",
          subscribedModules: [],
        })
      );
    };
  }, [
    companyDetail,
    isEdit,
    moduleNamesString,
    dispatch,
    sitePrefix,
    addNewDetails,
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateCompanyDetails(name, value));
  };

  const handleModuleToggle = (moduleId) => {
  const isSubscribed = editCompany.subscribedModules?.includes(moduleId);

  dispatch(
    updateCompanyDetails(
      "subscribedModules",
      isSubscribed
        ? editCompany.subscribedModules.filter((id) => id !== moduleId)
        : [...editCompany.subscribedModules, moduleId]
    )
  );
};

  const { data: activeModules, isLoading: activeModulesloading } =
    useGetActiveModules();

  const handleAddClient = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true)
      const token = localStorage.getItem("superAdminToken");

      if (!token) {
        return console.error("Token not found");
      }

    
      const payload = {
        company_name: editCompany?.name,
        company_email: editCompany?.email,
        company_phone: editCompany?.contact,
        site_url: editCompany?.site,
        no_of_users: editCompany?.users,
        duration: editCompany?.subscriptionType === '3months' ? 3 : editCompany?.subscriptionType === '6months' ? 6 : 12,
        modules: editCompany.subscribedModules.map((id) => ({ id })),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/super-admin/client-management/add-client`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuccessMessage(response.data.message);
      console.log({ response });
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    } catch (error) {
      setIsLoading(false);

      const apiErrors = error?.response?.data?.errors;
      const fallbackMessage =
        error?.response?.data?.message || "Something went wrong";

      if (apiErrors && typeof apiErrors === "object") {
        // Always extract the first message
        const firstErrorMessage =
          Object.values(apiErrors)[0]?.[0] || fallbackMessage;
        setErrorMessage(firstErrorMessage);
      } else {
        setErrorMessage(fallbackMessage);
      }

      console.error("Error:", error.response?.data || error.message);
    }
  };

  const renderViewMode = () => (
    <form>
      <div className="info-flex">
        <div className="info-section">
          <div className="info-group">
            <h1 className="info-label">Company Name:</h1>
            <span className="info-value">{companyDetail?.name} </span>
          </div>
          <div className="info-group">
            <h1 className="info-label">Company Site:</h1>
            <span className="info-value">{companyDetail?.site}</span>
          </div>
        </div>

        <div className="info-section">
          <div className="info-group">
            <h1 className="info-label">Company Email:</h1>
            <span className="info-value">{companyDetail?.email}</span>
          </div>
          <div className="info-group">
            <h1 className="info-label">Number of users:</h1>
            <span className="info-value">{companyDetail?.users}</span>
          </div>
        </div>

        <div className="info-section">
          <div className="info-group">
            <h1 className="info-label">Company Contact:</h1>
            <span className="info-value">{companyDetail?.phone}</span>
          </div>
          <div className="info-group">
            <h1 className="info-label">Subscribed Modules:</h1>
            <span className="info-value">
              {companyDetail?.subscribedModules}
            </span>
          </div>
        </div>
      </div>

      <h2>Available Modules</h2>
      <div className="modules-flex">
        {availableModules.map((module) => (
          <div key={module.id} className="module-card">
            <h4>{module.name}</h4>
            <div className="expiry-date">Expiry date: {module.expiryDate}</div>
          </div>
        ))}
      </div>
    </form>
  );

  const renderEditMode = () => (
    <>
      {successMessage && (
        <SuccessPopup
          message={successMessage}
          onClose={() => setSuccessMessage(null)}
        />
      )}
      {errorMessage && (
        <ErrorPopup
          message={errorMessage}
          onClose={() => setErrorMessage(null)}
        />
      )}

      <form onSubmit={handleAddClient}>
        <div className="info-flex">
          <div className="info-section">
            <div className="info-group">
              <h1 className="info-label">Company Name:</h1>
              <Input
                name="name"
                value={editCompany?.name}
                onChange={handleInputChange}
                placeholder="Enter company name"
                size="large"
              />
            </div>
            <div className="info-group">
              <h1 className="info-label">Company Site:</h1>
              <div className="site-input-wrapper">
                <Input.Group compact>
                  <Input
                    name="site"
                    value={editCompany?.site}
                    onChange={handleInputChange}
                    placeholder="Enter site name"
                    size="large"
                    style={{
                      width: "calc(100% - 220px)",
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                      borderRight: "none",
                    }}
                  />
                  <Input
                    value={`.${process.env.REACT_APP_CLIENT_WEBSITE_LINK || "workwavehr.sslinsight.com"}`}
                    size="large"
                    disabled
                    style={{
                      width: 220,
                      backgroundColor: "#16166c",
                      color: "white",
                      fontWeight: 500,
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      borderLeft: "1px solid #d9d9d9", 
                    }}
                  />
                </Input.Group>
              </div>
            </div>
          </div>

          <div className="info-section">
            <div className="info-group">
              <h1 className="info-label">Company Email:</h1>
              <Input
                name="email"
                type="email"
                value={editCompany?.email}
                onChange={handleInputChange}
                placeholder="Enter company email"
                size="large"
              />
            </div>
            <div className="info-group">
              <h1 className="info-label">Number of users:</h1>
              <Input
                id="number-input"
                name="users"
              
                value={editCompany?.users}
                 onChange={handleInputChange}
                size="large"
                className="input-number"
              />
            </div>
          </div>

          <div className="info-section">
            <div className="info-group">
              <h1 className="info-label">Company Contact:</h1>
              <Input
                name="contact"
                value={editCompany?.contact}
                onChange={handleInputChange}
                size="large"
                placeholder="Enter contact number"
              />
            </div>
            <div className="info-group">
  <h1 className="info-label">Subscription Type:</h1>
  <Select
    id="subscription-type"
    size="large"
    value={editCompany?.subscriptionType} // replace with your state field
    onChange={(value) => dispatch(updateCompanyDetails("subscriptionType", value))}
    style={{ width: "100%" }}
    options={[
      { value: "3months", label: "3 Months" },
      { value: "6months", label: "6 Months" },
      { value: "12months", label: "12 Months" },
    ]}
  />
</div>
          </div>
        </div>

        <h2>Subscription Details</h2>
        <div className="modules-flex">
          {activeModulesloading ? <SkeletonUI number={2}/> : (
            activeModules?.payload?.map((module) => (
            <div key={module.id} className="module-card module-card-border">
              <div className="module-checkbox-wrapper">
                <input
                  type="checkbox"
                  id={module.id}
                  checked={editCompany?.subscribedModules?.includes(module.id)}
                  onChange={() => handleModuleToggle(module.id)}
                />
                <label htmlFor={module.id} className="module-label">
                  {module.name}
                </label>
              </div>
            </div>
          ))
          )}
          
        </div>

        <div className="submit-wrapper">
          <button type="submit" className="submit-button">
            {isLoading ? <LoadingSpinner /> : "Add Client"}
          </button>
        </div>
      </form>
    </>
  );

  return (
    <div className="company-details">
      <div className="details-container">
        <h2>Company Details</h2>
        {isEdit || addNewDetails ? renderEditMode() : renderViewMode()}
      </div>
    </div>
  );
}
